<template>
  <main v-if='kql.page'>
    <!--<router-link :to="pathName(kql.page.parent?.url)">← Back</router-link>-->
    <h2 v-html='kql?.page?.title' />
    <h3 v-html='kql?.page?.content.intro' />
    <LayoutBlock v-if='kql.page?.content?.content' :block='block' v-for='block in JSON.parse(kql.page?.content?.content)' :context='kql.page' />
  </main>
</template>

<script setup>
import { pathName } from '@/utils'
import { useStore } from '@/KQL.js'
const kql = useStore();
</script>

<style scoped>
main {
  padding-top: var(--top-padding);
  margin: auto;
}

h1 {
  font-family: Motif;
  margin-bottom: 0.5em;
  letter-spacing:-.02em;
  max-width: 20em;
}

h2 {
  line-height: 1.1;
  max-width: 13em;
}

h3 {
  margin: 3rem auto;
  line-height: 1.3;
}


:deep(h1), :deep(h2), :deep(h3) {
  margin-bottom: 0.25em;
  text-align: left;
  margin-left: 2rem;
  margin-right: auto;
}

:deep(div.textblock) {
  margin-left: auto;
  margin-right: auto;
}

:deep(div.textblock p) {
  max-width: calc(100% - 1rem);
  text-align: left;
}


</style>
